import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";
import { Box, Typography, CircularProgress } from "@mui/material";
import styles from "../../screens2/Requirement/Requirement.module.css";
import {
  convertArrayToString,
  customTextColor,
  formatDate,
  formatTime,
} from "../../utils/const";
import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { allWorkAuthorization } from "../../redux/common/workAuthorizationSlice";
import { allLocation } from "../../redux/common/locationSlice";
import { allSkill } from "../../redux/common/skillSlice";
import { getProfile } from "../../redux/profile/profileSlice";
import ApplycandidateHistoryDrawer from "./ApplycandidateHistoryDrawer";
import { getAllMassmailHistoryOnJob } from "../../redux/massmail/massmailSlice";
const MassMailViewdrawer = ({ handleClose, show, jobdata }) => {
  const [showR, setShow] = useState(false);
  const [jobDetails, setJobDetetails] = useState({});
  const handleCloseShow = () => setShow(false);
  const handleShow = () => setShow(true);
  const dispatch = useDispatch();
  const locations = useSelector((state) => state.location);
  const skillData = useSelector((state) => state.skill.data);
  const profile = useSelector((state) => state.profile.data);
  const historyOneData = useSelector((state) => state.massmail.historyOneData);
  const massmailStatus = useSelector((state) => state.massmail.status);
  const getSkillNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          skillData?.locations?.find((location) => location.id === id)?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join("  , "); // Join names with a comma and space
  };

  const getPreferLocationNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          locations?.data?.locations?.find((location) => location.id === id)
            ?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join("  , "); // Join names with a comma and space
  };

  useEffect(() => {
    dispatch(allWorkAuthorization());
    dispatch(allLocation());
    dispatch(getProfile());
    dispatch(allSkill());
  }, [dispatch]);

  useEffect(() => {
    let jobID = jobdata?.job_id;
    dispatch(getAllMassmailHistoryOnJob(jobID));
  }, [jobdata]);

  useEffect(() => {
    if (historyOneData?.results?.length > 0) {
      setJobDetetails(historyOneData?.results?.[0]);
    }
  }, [historyOneData]);

  let totalCount =
    jobdata?.total_email_sent_to_candidate +
    jobdata?.total_email_sent_to_recruiter;

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "74px",
        width: "65%",
        padding: "0 0 0 10px",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 30px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography>
              Job ID: <b>{jobdata?.job_id}</b>
            </Typography>
            <Typography>
              Successfully send to: <b>{totalCount}</b>
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            flexDirection: "column",
            display: "flex",
            alignItems: "flex-end",
          }}
        >
          <RxCross2
            style={{
              fontSize: "22px",
              cursor: "pointer",
              marginBottom: "10px",
              color: customTextColor,
            }}
            onClick={handleClose}
          />
          <b style={{ alignSelf: "baseline" }}>
            {jobdata?.created_at !== undefined &&
              formatDate(jobdata?.created_at)}
            ,{" "}
            {jobdata?.created_at !== undefined &&
              formatTime(jobdata?.created_at)}
          </b>
        </Box>
      </Offcanvas.Header>
      <Offcanvas.Body style={{ paddingTop: "0" }}>
        {massmailStatus === "loading" ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 50,
            }}
          >
            <CircularProgress size={30} color="info" />
          </Box>
        ) : (
          <Box>
            <Box
              className={styles.profile_and_submit}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box>
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span>
                    <Typography>
                      <b>
                        {" "}
                        Job Post: Looking for {jobDetails?.no_of_opening}{" "}
                        {jobDetails?.job_title} at{" "}
                        {getPreferLocationNames(jobDetails?.location)}
                      </b>
                    </Typography>
                    <Typography>
                      <b>
                        {jobDetails?.job_title}, Exp {jobDetails?.experience}{" "}
                        Years {/* {getLocationById(jobDetails?.location)} */}
                      </b>
                    </Typography>
                    <Typography>
                      <b>
                        {convertArrayToString(jobDetails?.requirement_type)}{" "}
                      </b>
                    </Typography>
                    <Typography>
                      <b> {jobDetails?.mode_of_interview} </b>
                    </Typography>
                    <Typography>
                      <b>
                        {jobDetails?.rate !== "" || jobDetails?.rate !== null
                          ? `$${jobDetails?.rate} ${
                              jobDetails?.requirement_type?.includes(
                                "full_Time"
                              )
                                ? "K Yearly"
                                : " Hourly"
                            }`
                          : "Not disclosed"}{" "}
                      </b>
                    </Typography>
                    <Typography sx={{ marginTop: "10px !important" }}>
                      {jobDetails?.client_name !== "" &&
                        jobDetails?.client_name !== null && (
                          <b>Client : {jobDetails?.client_name}</b>
                        )}
                    </Typography>
                  </span>
                </span>
              </Box>
              <span style={{ alignSelf: "baseline" }}>
                <Typography
                  sx={{ fontSize: "25px !important", textAlign: "center" }}
                >
                  <b>{jobDetails?.no_of_opening}</b>
                </Typography>
                <Typography>
                  <b>No. Of Opening</b>{" "}
                </Typography>
              </span>
            </Box>

            <Box
              className={styles.candidate_text}
              sx={{ marginBottom: "14px" }}
            >
              <span>
                <Typography>
                  {/* <b>{jobDetails?.job_description}</b> */}
                  <b>
                    {" "}
                    {jobDetails?.job_description?.split("\n")?.map(
                      (line, index) =>
                        line?.trim() && (
                          <p
                            key={index}
                            style={{ marginBottom: "2px", padding: "0" }}
                          >
                            {line}
                          </p>
                        )
                    )}
                  </b>
                </Typography>
                <Typography>
                  <b>{getSkillNames(jobDetails?.skills)}</b>
                </Typography>
              </span>
            </Box>

            <div
              style={{
                backgroundColor: "#fff",
                padding: "5px 10px 5px 10px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box className={styles.recruiter_profile}>
                <div>
                  <img src={profile?.profile?.profile_picture} alt="" />
                  <span style={{ color: customTextColor }}>
                    <Typography>
                      <b>{profile?.profile?.full_name}</b>
                    </Typography>
                    <Typography>
                      <b>
                        {profile?.profile?.designation} at{" "}
                        {profile?.profile?.company_name}
                      </b>
                    </Typography>

                    <Typography sx={{ marginBottom: "5px !important" }}>
                      <Box>
                        <Typography>
                          <b>
                            E-Mail ID:{""}
                            {profile?.profile?.email}
                          </b>
                        </Typography>

                        <Typography sx={{ marginLeft: "10px" }}>
                          <b style={{ marginLeft: "10px" }}>
                            Phone No: {profile?.profile?.mobile_no}
                          </b>
                        </Typography>
                      </Box>
                    </Typography>
                  </span>
                </div>
              </Box>
              <Typography
                sx={{ textDecoration: "underline", cursor: "pointer" }}
                onClick={handleShow}
              >
                View Candidates
              </Typography>
            </div>

            <Box className={styles.massmailViewBtn}>
              <button
                style={{ backgroundColor: "#3856a6", marginRight: "20px" }}
              >
                Edit Mass Mail
              </button>

              <a style={{ fontSize: "20px", fontWeight: "bold" }}>OR</a>

              <button
                style={{ marginLeft: "15px", backgroundColor: "#4285f4" }}
              >
                Send Again
              </button>
            </Box>
          </Box>
        )}
      </Offcanvas.Body>
      <ApplycandidateHistoryDrawer
        handleShow={handleShow}
        handleClose={handleCloseShow}
        show={showR}
        historyOneData={historyOneData}
        totalCount={totalCount}
      />
    </Offcanvas>
  );
};

export default MassMailViewdrawer;
